









import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
@Component({
  components: { PublicLayout }
})
export default class Donate extends Mixins<SlotMixin>(SlotMixin) {
  created () {
    this.$gtag.event('page_view', {});
  }
}
